import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';
import {StyledSpinner} from './StyledSpinner';
import animationData from '../../static/images/spinner-logo.json';

const Spinner = ({
  size = 'medium',
  ...rest
}) => {
  const animationContainer = useRef(null);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData
    });

    return () => {
      anim.destroy();// Clean up when component unmounts
    };
  }, []);

  return (
    <StyledSpinner size={size} {...rest}>
      <div ref={animationContainer} />
    </StyledSpinner>
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large'])
};

export default Spinner;
